import { render, staticRenderFns } from "./JoinQuestion.vue?vue&type=template&id=466d803a&scoped=true&"
import script from "./JoinQuestion.vue?vue&type=script&lang=js&"
export * from "./JoinQuestion.vue?vue&type=script&lang=js&"
import style0 from "./JoinQuestion.vue?vue&type=style&index=0&id=466d803a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "466d803a",
  null
  
)

export default component.exports